/* global showVideoLightBox jQuery */
import { formatCurrencyV2 } from '../common/formatCurrency.ts';
import { addCommas } from '../utils/numberUtils.ts';
import { bindSmoothScroll } from '../utils/animation/smoothscroll.js';

(function () {
    $('.js-play-button').click(function (e) {
        showVideoLightBox(this.href);
        e.preventDefault();
    });

    function attachFaqListener() {
        $('body').on('click', '.js-single-question', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            const $svg = $(this).find('svg');
            if ($(this).hasClass('active')) {
                $svg.attr('class', 'icon icon-navigateup').html('<use xlink:href="/images/icon/icon-junior.svg#icon-navigateup"></use>');
            } else {
                $svg.attr('class', 'icon icon-navigatedown').html('<use xlink:href="/images/icon/icon-junior.svg#icon-navigatedown"></use>');
            }
        });

        // Prevents the FAQ div from closing when a link within it is clicked
        $('.js-faq-answer-link').click(function (event) {
            event.stopPropagation();
        });
    }

    function setOrgAge() {
        const d = new Date();
        const thisYear = d.getFullYear();
        const orgAge = thisYear - 2000;

        $('.js-org-age').html(orgAge);
    }

    $(function () {
        function setUpFloatingNav() {
            const stick = $('.js-navigation');
            let pos = stick.offset();

            /**
             * Some react components are loading after document.ready; trigger an "updateFirstSectionPosition" event
             * to recalc .js-first-section position.
             */
            $(document).on('updateFirstSectionPosition', function () {
                pos = stick.offset();
            });
            $(window).scroll(function () {
                if ($(this).scrollTop() > pos.top && stick.css('position') === 'static') {
                    stick.addClass('sticky');
                } else if ($(this).scrollTop() <= pos.top && stick.hasClass('sticky')) {
                    stick.removeClass('sticky');
                }
            });
        }

        if ($('.js-navigation').length > 0) {
            setUpFloatingNav();
        }

        //  Impact stats
        $.get(baseCacheURL + 'about/impact.json', function (data) {
            $('.js-dollarsRaised').html(formatCurrencyV2(jQuery.parseJSON(data.stats.dollarsRaised), 'HIDE_CENTS'));
            $('.js-classroomProjectsFunded').html(addCommas(jQuery.parseJSON(data.stats.projectsFunded), false));
            $('.js-supporters').html(addCommas(jQuery.parseJSON(data.stats.supporters), false));
            $('.js-publicSchools').html(addCommas(jQuery.parseJSON(data.stats.publicSchools), false) + '%');
            $('.js-teachersFunded').html(addCommas(jQuery.parseJSON(data.stats.teachersProjectsFunded)));
            $('.js-projectsFunded').html(addCommas(jQuery.parseJSON(data.stats.projectsFunded)));
        });

        window.setUpFloatingNav = setUpFloatingNav;
        bindSmoothScroll();
        attachFaqListener();
        setOrgAge();
    });
})();
